import { parse } from 'hub-http/helpers/params';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import { FireAlarm } from 'foundations-components/transitional/components/FireAlarm';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
class TwoFactorSetupReturnBackTo extends Component {
  constructor(props) {
    super(props);
    const search = window.location.search;
    const {
      returnBackTo
    } = search.length > 0 ? parse(search.substr(1)) : {};
    this.state = {
      returnBackTo
    };
  }
  render() {
    const {
      returnBackTo
    } = this.state;
    if (!returnBackTo) {
      return null;
    }
    return /*#__PURE__*/_jsx(FireAlarm, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.alerts.twoFactorSetup.title"
      }),
      type: "info",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        options: {
          href: returnBackTo,
          use: 'on-bright'
        },
        message: "userPreferences.alerts.twoFactorSetup.message_jsx"
      })
    });
  }
}
export default TwoFactorSetupReturnBackTo;